import { render, staticRenderFns } from "./BlockSearchQuery.vue?vue&type=template&id=a9aae4ce"
import script from "./BlockSearchQuery.vue?vue&type=script&lang=js"
export * from "./BlockSearchQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports